import { createStore } from 'vuex'
import userModule from './modules/user'
import notesModule from './modules/notes'
import reviewsModule from './modules/reviews'
import tagsModule from './modules/tags'
import auth from './modules/auth'
import wordBook from './modules/wordBook'

export default createStore({
  state: {
    appLoading: false,
    darkMode: false,
    notifications: []
  },
  getters: {
    isLoading: state => state.appLoading,
    isDarkMode: state => state.darkMode,
    getNotifications: state => state.notifications
  },
  mutations: {
    SET_LOADING(state, status) {
      state.appLoading = status
    },
    TOGGLE_DARK_MODE(state) {
      state.darkMode = !state.darkMode
      localStorage.setItem('darkMode', state.darkMode)
    },
    ADD_NOTIFICATION(state, notification) {
      state.notifications.push({
        id: Date.now(),
        ...notification
      })
    },
    REMOVE_NOTIFICATION(state, id) {
      state.notifications = state.notifications.filter(n => n.id !== id)
    }
  },
  actions: {
    setLoading({ commit }, status) {
      commit('SET_LOADING', status)
    },
    toggleDarkMode({ commit }) {
      commit('TOGGLE_DARK_MODE')
    },
    showNotification({ commit }, notification) {
      commit('ADD_NOTIFICATION', notification)
      setTimeout(() => {
        commit('REMOVE_NOTIFICATION', notification.id)
      }, notification.timeout || 3000)
    }
  },
  modules: {
    user: userModule,
    notes: notesModule,
    reviews: reviewsModule,
    tags: tagsModule,
    auth,
    wordBook
  }
}) 